import ArticleEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/article_embed';
import ArticleGridEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/article_grid_embed';
import BrandCalloutEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/callouts/brand';
import CalloutEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/callout_embed';
import CategoryCalloutEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/callouts/category';
import ComparisonShoppingPageCardManager from '@reverbdotcom/discovery-ui/src/components/discovery/csp/csp_card_manager';
import CSPMiniGridEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/csp_mini_grid_embed';
import HandpickedCalloutEmbed from '@reverbdotcom/discovery-ui/src/components/embeds/callouts/handpicked';
import VideoEmbed from '@reverbdotcom/commons/src/components/video_embed';

window.Reverb = { ...window.Reverb,
  ArticleEmbed,
  ArticleGridEmbed,
  BrandCalloutEmbed,
  CalloutEmbed,
  CategoryCalloutEmbed,
  ComparisonShoppingPageCardManager,
  CSPMiniGridEmbed,
  HandpickedCalloutEmbed,
  // this component is still embedded in articles, leaving it defined but as a no-op
  LPAlbumRowEmbed: () => { return null; },
  VideoEmbed,
};
